import { FirebaseApp, getApp, getApps, initializeApp } from "firebase/app";
import { Analytics, getAnalytics } from "firebase/analytics";
import { Database, getDatabase } from "firebase/database";
import { Auth, getAuth } from "firebase/auth";
import { Firestore, getFirestore } from "firebase/firestore";
import { FirebaseStorage, getStorage } from "firebase/storage";

const firebaseConfig = {
    apiKey: process.env.REACT_APP_API_KEY,
    authDomain: process.env.REACT_APP_AUTH_DOMAIN,
    projectId: process.env.REACT_APP_PROJECT_ID,
    storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
    databaseURL: process.env.REACT_APP_DATABASE_URL,
    messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
    appId: process.env.REACT_APP_APP_ID,
    measurementId: process.env.REACT_APP_MEASUREMENT_ID,
};

let app: FirebaseApp;
let analytics: Analytics;
let dbFirestore: Firestore;
let dbRealtime: Database;
let auth: Auth;
let storage: FirebaseStorage;

const getFirebaseApp = (): FirebaseApp => {
    if (!getApps().length) {
        app = initializeApp(firebaseConfig);
    } else {
        app = getApp();
    }
    return app;
};

export const getFirebaseServices = () => {
    const firebaseApp = getFirebaseApp();
    if (!dbFirestore) {
        analytics = getAnalytics(firebaseApp);
        dbFirestore = getFirestore(firebaseApp);
        dbRealtime = getDatabase(firebaseApp);
        auth = getAuth(firebaseApp);
        storage = getStorage(firebaseApp);
    }
    return { firebaseConfig, analytics, dbFirestore, dbRealtime, auth, storage };
};
